import type { ReactNode } from "react"
import { AppShell } from "../layout/app-shell"

export function QueuesShell({ children, actions }: { children: ReactNode; actions?: ReactNode }) {
  return (
    <div>
      <AppShell
        title="Nutrition image queue"
        hideTitle
        fullWidth
        contentClassName="px-4 pt-5 pb-24 sm:px-6 sm:pt-6 sm:pb-24 lg:px-12 lg:pt-10"
      >
        <div className="mx-auto min-w-0 max-w-[1160px] text-[14px] leading-[1.5] motion-reduce:[&_*]:animate-none! motion-reduce:[&_*]:transition-none! motion-reduce:[&_*::before]:animate-none! motion-reduce:[&_*::before]:transition-none! motion-reduce:[&_*::after]:animate-none! motion-reduce:[&_*::after]:transition-none!">
          <header className="mb-6 flex flex-wrap items-end justify-between gap-4">
            <div>
              <h1 className="text-[28px] font-semibold leading-[1.2] tracking-tight max-sm:text-[24px]">
                Nutrition image queue
              </h1>

              <p className="mt-1.5 text-muted-foreground">
                Every PIM nutrition change, from receipt to a current image in GCS and a published
                event.
              </p>
            </div>

            {actions}
          </header>

          <div className="grid min-w-0 gap-4">{children}</div>
        </div>
      </AppShell>
    </div>
  )
}
